export const LinksStrings = {
  termsOfService: (lang = 'en') => `https://www.logmein.com/${lang}/legal/terms-and-conditions`,
  privacyPolicy: (lang = 'en') => `https://www.logmein.com/${lang}/legal/privacy`,
  goToWebinarPrivacyPolicy: (lang = 'en') => `https://www.logmein.com/${lang}/legal`,
};
